import { useState } from "react";
import React from "react";
import { ComposedModal, Button, ModalBody, ModalHeader, Grid, Row, Column } from "carbon-components-react";

function DentalPlanDetails() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ComposedModal open={open} onClose={() => setOpen(false)}>
        <ModalHeader className="mt-4 mb-4 -ml-4">
          <p className="text-left text-2xl">MetLife Dental PDP Plus Plan Details</p>
        </ModalHeader>
        <ModalBody aria-label="Plan Details">
          <div className="-ml-10 px-4">
            <Grid className="mb-8">
              <Row className="bg-gray-400">
                <Column></Column>
                <Column className="py-2 font-bold ">In-Network</Column>
                <Column className="py-2 font-bold ">Out-of-Network</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Benefit Year Deductible</Column>
                <Column className="mt-2 mb-2">
                  $50 Per Person / Maximum of 3 Per Family.
                  <br />
                  Deductible Waived for Preventive Services.
                </Column>
                <Column className="mt-2 mb-2">(same as in-network)</Column>
              </Row>
              <Row className="bg-gray-200">
                <Column className="mt-2 mb-2">Benefit Year Maximum - Not Combined</Column>
                <Column className="mt-2 mb-2">$1,500 Per Person</Column>
                <Column className="mt-2 mb-2">$1,000 Per Person</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Coinsurance</Column>
              </Row>
              <Row className="bg-gray-200">
                <Column className="mt-2 mb-2">Basic Services</Column>
                <Column className="mt-2 mb-2">Plan Pays 90%</Column>
                <Column className="mt-2 mb-2">Plan Pays 80% of Allowable Charge</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Major Services</Column>
                <Column className="mt-2 mb-2">Plan Pays 60%</Column>
                <Column className="mt-2 mb-2">Plan Pays 50% of Allowable Charge</Column>
              </Row>
              <Row className="bg-gray-200">
                <Column className="mt-2 mb-2">Child Orthodontia Services</Column>
                <Column className="mt-2 mb-2">Plan Pays 50% Lifetime Maximum - $1,000 Per Covered Child</Column>
                <Column className="mt-2 mb-2">(same as in-network)</Column>
              </Row>
            </Grid>
          </div>
          <div >
            <div className="mb-6 -ml-2 sm:ml-0">
              <div className="py-1 text-left font-bold text-red-600">Website and Customer Service Information</div>
              <p>
                www.metlife.com
                <br />
              </p>
              Customer Service: 800-942-0854
            </div>
          </div>
          <div className="mb-8 -ml-2 sm:ml-0">
            <div className="py-1 text-left font-bold text-red-600">Important Information</div>
            <p>• Orthodontic benefits for dependents up to age 19</p>
          </div>
        </ModalBody>
      </ComposedModal>
      <Button kind="ghost" onClick={() => setOpen(true)}>
        View Plan Details
      </Button>
    </>
  );
}

export default DentalPlanDetails;
